/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit } from '@angular/core';
import { ProductPlanTier, UserService } from '../services/user.service';
import { AppsService } from '../services/apps.service';
import { CreditUsageModalComponent } from './modals/credit-usage-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'manage-subscription',
  templateUrl: './manage-subscription.component.html',
  styleUrls: ['./manage-subscription.component.less'],
  standalone: false,
})
export class ManageSubscriptionComponent implements OnInit {
  acquisition: any;
  isSubscriptionExpired: boolean;

  constructor(
    private userService: UserService,
    private appsService: AppsService,
    private modalService: NgbModal,
  ) {}
  planName = '';

  async refresh() {
    if (!window.document.hidden && this.userService?.user?.id) {
      try {
        await this.appsService.getActiveAcquisitions(this.userService.user.id);
        this.checkToDisplayExpiredNotice();
      } catch (error) {
        console.log(error);
      }
    }
  }

  ngOnInit() {
    this.refresh();
  }

  checkToDisplayExpiredNotice() {
    this.acquisition = this.userService?.user?.acquisition;
    this.isSubscriptionExpired =
      this.userService?.user?.isSubscriptionExpired || false;

    if (!this.isSubscriptionExpired && this.acquisition) {
      if (this.acquisition.productPlanTier == ProductPlanTier.Starter) {
        this.planName = 'SDE_STARTER';
      } else {
        this.planName = 'SDE_ADVANCED';
      }
    }
  }

  async redirect(action: any) {
    await this.userService.redirect(action);
  }

  async usage() {
    this.modalService.open(CreditUsageModalComponent, {
      windowClass: 'xrx-modal',
      size: 'lg',
    });
  }
}
